import React, {useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import {history} from "../../../routers/AppRouter";
import moment from 'moment';
import styled from 'styled-components'
import { useTable, useRowSelect } from 'react-table';
import {connect} from "react-redux";

import MainButton from '../../../components/MainButton';
import {getAds, removeAds} from '../../../actions/ads';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const Title = styled.div`
  cursor: pointer;
`;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    )
  }
);

const handleEditRow = (id) => {
  history.push(`ad/${id}`);
};

const createPost = () => {
  history.push('/ad')
};

function Table({ columns, data, deleteSelectedAds }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    hooks => {
      hooks.allColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  );

  // Render the UI for your table
  return (
    <>
      <HeadingContainer>
        <StyledHeading>Ad Manager</StyledHeading>
        <MainButton title="Post an Ad" onClick={() => createPost()} />
        <MainButton title="Delete Ads" onClick={() => deleteSelectedAds(selectedFlatRows)} />
      </HeadingContainer>
      <table {...getTableProps()}>
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()}>
        {rows.slice(0, 50).map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
        </tbody>
      </table>
      <p>Selected Rows: {Object.keys(selectedRowIds).length}</p>
      <pre>
        <code>
          {JSON.stringify(
            {
              selectedRowIds: selectedRowIds,
              'selectedFlatRows[].original': selectedFlatRows.map(
                d => d.original
              ),
            },
            null,
            2
          )}
        </code>
      </pre>
    </>
  )
}

function AdManager(props) {

  // had to be in here to get be able to fire props dispatch
  const deleteSelectedAds = (selectedRows) => {
    let adIdsToDelete = [];
    selectedRows.map((item) => {
      adIdsToDelete.push(parseInt(item.original.id, 10)); // original is the actual object info
    });
    props.removeAds(adIdsToDelete);
  };

  useEffect(() => {
    props.getAds();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Ads Info',
        columns: [
          {
            Header: 'Ad Name',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data.id)}>{data.name}</Title>;
            },
          },
          {
            Header: 'Sponsor',
            accessor: 'sponsor',
          },
          {
            Header: 'Date',
            accessor: d => {
              return moment(d.date).format('MMM. Do, YYYY');
            }
          },
          {
            Header: 'Application Type',
            accessor: 'applicationType',
          },
          {
            Header: 'Placement',
            accessor: 'placement',
          },
          {
            Header: 'Status',
            accessor: 'status',
          }
        ],
      },
    ],
    []
  );

  return (
    <Styles>
      {
        props.ads.length > 0 &&
        <Table columns={columns} data={props.ads} deleteSelectedAds={deleteSelectedAds} />
      }
    </Styles>
  )
}

const mapStateToProps = (state) => {
  return {
    ads: state.ads.data
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAds: () => dispatch(getAds()),
  removeAds: (idsToDelete) => dispatch(removeAds(idsToDelete)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdManager);
